// El cuerpo del error puede venir como objeto o como JSON en texto plano.
// Devuelve null cuando no hay nada parseable (error de red, 500, timeout).
const datosDeRespuesta = (error) => {
  const data = error?.response?.data;
  if (typeof data !== 'string') return data ?? null;
  try {
    return JSON.parse(data);
  } catch (e) {
    return null;
  }
};

// El backend valida el DTE antes de asignarle folio y, cuando lo rechaza,
// responde 400 con { msg, errores: [...] }. Mostrar esa lista es mucho más útil
// que un "ocurrió un error" genérico, porque dice exactamente qué corregir.
//
// Devuelve el array de errores, o null si la respuesta no trae ese formato
// (error de red, 500, timeout), caso en que corresponde el mensaje genérico.
export const erroresDeRespuesta = (error) => {
  const data = datosDeRespuesta(error);
  return Array.isArray(data?.errores) && data.errores.length > 0 ? data.errores : null;
};

// Las validaciones previas al DTE (por ejemplo la sucursal del emisor) responden
// 400 con { msg } y sin lista de errores: ese texto ya explica qué pasó.
export const mensajeDeRespuesta = (error) => datosDeRespuesta(error)?.msg || null;
